<template>
  <breadcrumb-page :list="breadcrumb_links"></breadcrumb-page>

  <div id="maincontent_container">
    <submenu-support menu="rma"></submenu-support>

    <!-- page content on the right -->
    <div class="submenu-content">
      <div class="rmaRequest">
        <!-- New RMA Entrypoint via serial or invoice # search -->
        <div v-if="!loggedIn" class="lead">
          Please <router-link to="/login">log in</router-link> to start an RMA
          Request. If you do not have an account, please <router-link to="/rma-registration">register</router-link> an RMA account.
        </div>
        <div v-else>
          <p class="lead">Start Online RMA Request</p>
          <p>Input a valid invoice or serial number and click the button to start an RMA Request.</p>
          <p class="text-danger">For repeated RMA requests, use the original invoice number.</p>
          <div v-if="hasErrors" class="error-banner" id="errors-banner">
            <span class="fw-bold">Note:</span> We could not find the serial number(s) <span class="fw-bold">{{ contact_support.join(', ') }}</span> in our records. Please double check the number or try searching with the invoice number. If both serial and invoice numbers cannot be found, please contact rma@malabs.com for assistance.
          </div>
          <div class="search-container">
            <input
              type="text"
              v-model="invoice"
              placeholder="Type Invoice #"
              @input="errors.id_no = ''"
              @keydown.enter="handleRMARequest('invoice')"
            />
            <div v-if="askForCustNo && invoice.trim() !== ''">
              <input
                type="text"
                v-model="request_custno"
                placeholder="Type Customer #"
                @keydown.enter="handleRMARequest('invoice')"
              />
            </div>
            <button @click="handleRMARequest('invoice')">
              Start with Invoice #
            </button>
          </div>
          <div class="search-container">
            <input
              type="text"
              v-model="serial"
              placeholder="Type Serial #"
              @input="errors.id_no = ''"
              @keydown.enter="handleRMARequest('serial')"
            />
            <div v-if="askForCustNo && serial.trim() !== ''">
              <input
                type="text"
                v-model="request_custno"
                placeholder="Type Customer #"
                @keydown.enter="handleRMARequest('serial')"
              />
            </div>
            <button @click="handleRMARequest('serial')">
              Start with Serial #
            </button>
          </div>
          <div v-if="errors.id_no" class="text-danger">{{ errors.id_no }}</div>
        </div>
      </div>
      <br />
      <p>
        <a target="_blank" class="blue_link" :href="'/' + items[1]"
          ><b>Review</b>&nbsp;
          <img :src="items[4]" />
        </a>
        &nbsp; &nbsp; <b>Limited Warranty &amp; RMA Service Policy</b>
      </p>
      <br />
      <p>
        <a
          target="_blank"
          class="blue_link"
          :href="'/'+ items[3]"
          ><b>Review</b>&nbsp;
          <img :src="items[4]" />
        </a>
        &nbsp; &nbsp; <b>Ma Labs Complete System RMA Policy and Procedure</b>
      </p>
      <br />
      <!-- <p class="lead">Submit Paper-based RMA</p>
      <p>
        <a target="_blank" class="blue_link" :href="'/' + items[2]"
          ><b>RMA Form (Excel File)</b></a
        >
      </p> -->
      <p>
        Northern California Service Center - San Jose, CA <br />
        2075 N . Capitol Avenue, San Jose, CA 95132 <br />
        Tel No:408-941-0808 Press 7 and then Press 1 <br />
        Email:
        <a class="blue_link" :href="items[2]">rma@malabs.com</a><br />
        <br />
        Southern California Service Center - City of Industry, CA <br />
        18725 San Jose Avenue,City of Industry,CA 91748<br />
        Tel No: 626-820-8988 Ext 145<br />
        Email:
        <a class="blue_link" href="mailto:rma@malabs.com">rma@malabs.com</a
        ><br />
      </p>
    </div>
  </div>
</template>

<script>
import SubmenuSupport from "../../components/nav/SubmenuSupport.vue";
import BreadcrumbPage from "../../components/BreadcrumbPage.vue";
import { getAPI } from "../../utils/axios-api";
import { getAuthAPI } from "../../utils/axios-api";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { computed, reactive } from "vue";

export default {
  name: "RMARequest",
  components: { SubmenuSupport, BreadcrumbPage },
  setup() {
    const RMARequest = ref("");
    const items = ref([]);
    const error = ref(null);
    const invoice = ref("");
    const serial = ref("");
    const errors = reactive({ id_no: "" });
    // For requesting customer number if user account customer number doesn't match invoice customer number
    const request_custno = ref("");
    const askForCustNo = ref(false);

    const router = useRouter();
    const store = useStore();

    // use store to get login status and customer number
    const loggedIn = computed(() => store.getters.isAuthenticated);

    // Make custno reactive based on authentication status
    const custno = computed(() => (loggedIn.value ? store.getters.custno : ""));

    // Added list of invalid serial number searches
    const contact_support = ref([]);
    const hasErrors = computed(() => {
      return (
        contact_support.value.length > 0
      );
    });

    const handleRMARequest = (type) => {
      // reset errors
      errors.id_no = "";
      // get id_no, make sure it's not empty
      let id_no = "";
      if (type === "invoice") {
        if (invoice.value.trim() === "") {
          errors.id_no =
            "Please enter a valid invoice number to start an RMA request.";
          return;
        }
        id_no = invoice.value.trim();
      } else if (type === "serial") {
        if (serial.value.trim() === "") {
          errors.id_no =
            "Please enter a valid serial number to start an RMA request.";
          return;
        }
        const cleaned_serial = serial.value.trim().replace(/[\s\-_]/g, "")
        id_no = cleaned_serial;
      }
      // validate custno
      if (custno.value == "") {
        errors.id_no = "You must be a customer to submit an RMA request.";
        return;
      }
      // Only use request_custno if askForCustNo is true and request_custno is not empty
      var url = "rma/search/" + type + "/" + id_no + "/" + (askForCustNo.value && request_custno.value ? request_custno.value.trim() + "/" : "");
      getAuthAPI
        .get(url)
        .then((response) => {
          let ord = response.data.results;
          // start RMA Request Form with the initial invoice customer number
          const rmaRequestUrl = `/rma-request/${type}/${id_no}/${ord.custno.toUpperCase()}`;
          router.push(rmaRequestUrl);
        })
        .catch((err) => {
          const expectedStatuses = [400, 404];
          if (err.response && err.response.status === 404) {
            if (err.response.data.code === "rma_account_mismatch") {
              askForCustNo.value = true;
              errors.id_no = "Your account information does not match this invoice. Please also provide the customer number listed on your invoice and try again. If you still encounter this error, please contact rma@malabs.com for assistance.";
            } else if (err.response.data.code === "invalid_request_custno") {
              errors.id_no = `The customer number ${request_custno.value} you provided does not match our records for this invoice. Please double check and try again.`;
            } else {
              if (type === "invoice") {
                errors.id_no = err.response.data.message;
              } else if (type === "serial") {
                if (!contact_support.value.includes(id_no)) {
                  contact_support.value.push(id_no);
                }
              }
            }
            request_custno.value = "";
          } else if (err.response && expectedStatuses.includes(err.response.status) && err.response.data.message) {
            // Django response with error message
            console.error(err);
            console.log("error: ", err.response.data.message);
            errors.id_no =
              "An unexpected error occurred. Please contact rma@malabs.com with a description of your issue if it persists.";
          } else {
            // unexpected error; no django response message
            console.error(err);
            errors.id_no =
              "An unexpected error occurred. Please contact rma@malabs.com with a description of your issue.";
          }
          return;
        });
    };

    //breadcrumb
    const breadcrumb_links = ref([]);
    breadcrumb_links.value.push({ text: "Support", link: "" });
    breadcrumb_links.value.push({ text: "RMA Request", link: "RMARequest" });

    // Gets content for different files and images
    // First item is Online RMA service url no longer used.
    let url = "content/pages/57";
    getAPI
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          RMARequest.value = response.data.body;
          for (let index in RMARequest.value) {
            if (RMARequest.value[index].type == "image") {
              items.value.push(RMARequest.value[index].value.thumbnail.src);
            } else {
              items.value.push(RMARequest.value[index].value);
            }
          }
        }
      })
      .catch((err) => {
        error.value = "No page Found";
      });

    return {
      items,
      error,
      breadcrumb_links,
      loggedIn,
      invoice,
      custno,
      serial,
      errors,
      // isValidIdno,
      askForCustNo,
      request_custno,
      handleRMARequest,
      contact_support,
      hasErrors,
    };
  },
};
</script>

<style scoped>
.lead {
  font-size: 26px;
  font-family: "Roboto";
  font-weight: 600;
  color: #555555;
}
body {
  min-width: 300px;
  color: #555555;
  font-family: Segoe, Arial;
  font-size: 16px;
}
.submenu-content a {
  color: #1ed2e9;
}
div >>> .rmaRequest a {
  color: #1ed2e9;
}
.alert .alert-link,
.close,
b,
optgroup,
strong {
  font-weight: 700;
}

.search-container {
  display: flex;
  justify-content: left;
  align-items: center;
  margin-top: 10px;
  gap: 5px;
}

.search-container input {
  padding: 8px;
  font-size: 14px;
  /* width: 100px; */
  border: 1px solid #ccc;
  border-radius: 4px;
}

.search-container input {
  width: 300px;
}

.search-container button {
  padding: 8px 12px;
  font-size: 14px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.search-container button:hover,
button:hover {
  background-color: #0056b3;
}

.error-banner {
  background-color: #f8d7da; /* Light red background */
  color: #721c24; /* Dark red text */
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #f5c6cb; /* Light red border */
}
</style>
